import React from 'react';

import { BrowserTitleService } from '~commonInfra/services/BrowserTitleService';
import { AllUserIdentitiesSubspaceStyles } from '~src/authentication/styles/AllUserIdentitiesSubspaceStyles';
import { BreadcrumbStateInfo } from '~src/spacesPlatform/components/breadcrumbs/BreadcrumbStateInfo';
import { ConnectedExplorer } from '~src/spacesPlatform/components/Explorer/ConnectedExplorer';
import { SpaceHeaderWithTotalItemsCount } from '~src/spacesPlatform/components/header/SpaceHeaderWithTotalItemsCount';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';

import { ServerUrls } from '../../../../app/ServerUrls';
import { LicenseInfoBar } from '../../../../app/spaces/Header/LicenseInfoBar';
import { Messages } from '../../../../codegen/Localize';
import { AddUsersButton } from '../../../components/AddUsersButton';

export interface AllServerUsersSpaceOwnProps {
  readonly shouldRenderAsSubspace: boolean;
}

export interface AllServerUsersSpaceStateProps {
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedUsers: number;
}

export interface AllServerUsersSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
  readonly updateBreadcrumbs: (breadcrumbs: ReadonlyArray<BreadcrumbStateInfo>) => void;
}

export type AllServerUsersSpaceProps = AllServerUsersSpaceOwnProps & AllServerUsersSpaceStateProps & AllServerUsersSpaceDispatchProps;

export class AllServerUsersSpace extends React.PureComponent<AllServerUsersSpaceProps> {
  public constructor(props: AllServerUsersSpaceProps) {
    super(props);
  }

  public componentDidMount() {
    this.props.updateBreadcrumbs([getServerUsersSpaceBreadcrumb()]);
    BrowserTitleService.setTitleWithTranslatedSpace({translatedSpaceName: Messages.serverUsers()});
    this.props.requestSpaceContents();
  }

  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        {this.renderComponentHeader()}
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            supportedDisplayModes={['list']}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled',
              toolbarContentSpecificControls: { beginning: this.addUsersButton() }
            }}
            emptyStateProps={{
              primaryMessage: Messages.usersEmptyMessage()
            }}
          />
        </div>
      </div>
    );
  }

  private renderComponentHeader = (): JSX.Element => {
    if (this.props.shouldRenderAsSubspace) {
      // The space header is already defined.
      return <div className={AllUserIdentitiesSubspaceStyles.MastheadArea}>
        {this.licenseBar()}
        </div>;
    } else {
      return <SpaceHeaderWithTotalItemsCount
          onClick={this.onSpaceHeaderClick}
          label={Messages.serverUsers()}
          testId={'server-users'}
          count={this.props.numberOfFetchedUsers}
          countUpToDate={!this.props.isBusyFetchingItems}
          licenseInfoBar={this.licenseBar}
        />;
    }
  }

  private licenseBar = (): JSX.Element => {
    return <LicenseInfoBar
      hasSiteLicensingInfo={false}
    />;
  }

  private onSpaceHeaderClick = () => {
    this.props.requestSpaceContents();
  }

  private addUsersButton = (): JSX.Element => {
    return (
      <AddUsersButton isServerUsersSpace={true}
                      requestSpaceContents={this.props.requestSpaceContents}
                      addButtonText={Messages.addUsers()}/>
    );
  }
}

export function getServerUsersSpaceBreadcrumb(): BreadcrumbStateInfo {
  const serverUrls = ServerUrls.getInstance();
  return {
    id: serverUrls.usersUrl(),
    text: Messages.allServerUsers(),
    href: serverUrls.usersUrl(),
    testId: 'server-users-link'
  };
}
